module.exports = __webpack_public_path__ + "public/images/shedule-bel.ccfb41b34cf3ab603c8a6e6a89057a94.png";